/** Download tabular data as CSV (opens correctly in Excel with UTF-8 BOM). */
export function downloadCsv(filename, headers, rows) {
    const escape = (cell) => {
        const s = cell == null ? '' : String(cell);
        if (/[",\n\r]/.test(s)) {
            return `"${s.replace(/"/g, '""')}"`;
        }
        return s;
    };
    const lines = [
        headers.map(escape).join(','),
        ...rows.map((row) => row.map(escape).join(',')),
    ];
    const bom = '\uFEFF';
    const blob = new Blob([bom + lines.join('\n')], {type: 'text/csv;charset=utf-8;'});
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
